export const PARTNER360_NAMESPACE = 'partner360'

export const P360_PAGE_URL = 'jbl-hpscoutso'
export const P360_GLOBAL_PAGE_URL = 'jbl-hpscoutso-global'
export const MANAGER_COCKPIT_PAGE_URL = 'jbp-cockpit'
export const OFFERING_URL = 'ptype'
export const PID_URL = 'pid'
export const FYEAR_URL = 'fyear'
export const TAB_URL = 'jbp-tab'
export const P360_TAB_SCROLL_QUERY_PARAM = 'scrollToTab'
export const P360_TAB_SCROLL_QUERY_VALUE = '1'

export const FINANCIAL_SECTION_URL_VALUE = '20'
export const INITIATIVES_SECTION_URL_VALUE = '21'

export const PLANNING_SECTION_URL_SEGMENT = 'fct'
export const PLANNING_METRIC_URL_SEGMENT = 'avt'
export const LOCAL_CURRENCY_URL_SEGMENT = 'lc'

export const F_QUARTERS = [1, 2, 3, 4]
